export interface ContextoMarcarPedidoPagoAoCriar {
  pedido?: {
    id?: any;
    mesa?: any;
  };
  orderType?: string;
  routeContext?: {
    idMesa?: any;
    idComanda?: any;
    idCartaoConsumo?: any;
    idGarcom?: any;
    modoGarcom?: any;
    novaComanda?: any;
  };
  mesaSelecionada?: any;
  comandaSelecionada?: any;
}

function temValor(valor: any): boolean {
  return valor !== undefined && valor !== null && valor !== '' && valor !== false;
}

function parametroAtivo(valor: any): boolean {
  if (valor === true || valor === '' || valor === 1) return true;
  const normalizado = String(valor ?? '').trim().toLowerCase();
  return ['1', 'true', 't', 'yes', 'y', 'sim'].includes(normalizado);
}

export function ehContextoPedidoMesa(contexto: ContextoMarcarPedidoPagoAoCriar = {}): boolean {
  const routeContext = contexto.routeContext || {};

  return contexto.orderType === 'mesa'
    || !!contexto.pedido?.mesa
    || temValor(routeContext.idMesa)
    || temValor(routeContext.idComanda)
    || temValor(routeContext.idCartaoConsumo)
    || temValor(routeContext.idGarcom)
    || parametroAtivo(routeContext.modoGarcom)
    || parametroAtivo(routeContext.novaComanda)
    || !!contexto.mesaSelecionada
    || !!contexto.comandaSelecionada;
}

export function podeExibirMarcarPedidoPagoAoCriar(contexto: ContextoMarcarPedidoPagoAoCriar = {}): boolean {
  if (contexto.pedido?.id) return false;
  return !ehContextoPedidoMesa(contexto);
}
